import * as CartService from '../services/CartService'

export const UPLOAD_FILE_TO_PARTICIPANT_REQUEST = 'UPLOAD_FILE_TO_PARTICIPANT_REQUEST';
export const UPLOAD_FILE_TO_PARTICIPANT_SUCCESS = 'UPLOAD_FILE_TO_PARTICIPANT_SUCCESS';
export const UPLOAD_FILE_TO_PARTICIPANT_FAILURE = 'UPLOAD_FILE_TO_PARTICIPANT_FAILURE';

export function uploadFileToParticipantRequest() {
    return {
        type: UPLOAD_FILE_TO_PARTICIPANT_REQUEST
    }
}

export function uploadFileToParticipantSuccess(payload) {
    return {
        type: UPLOAD_FILE_TO_PARTICIPANT_SUCCESS,
        payload
    }
}

export function uploadFileToParticipantFailure(payload) {
    return {
        type: UPLOAD_FILE_TO_PARTICIPANT_FAILURE,
        payload
    }
}

export function uploadFileToParticipant(file, fileName, fieldName, itemIdentifier, participantIdentifier) {
    return (dispatch) => {
        dispatch(uploadFileToParticipantRequest());

        CartService.uploadFileToParticipant(file, fileName, fieldName, itemIdentifier, participantIdentifier)
            .then(response => {
                dispatch(uploadFileToParticipantSuccess(response));
            })
            .catch(error => {
                dispatch(uploadFileToParticipantFailure(error));
            });
    }
}
